import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const baseRouters = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/view/login/login.vue"),
  },
  {
    path: "/info_collect", // 信息采集页，最外层，无需权限
    name: "infoCollect",
    component: () => import("@/view/infoCollect/index.vue"),
  },
];

const createRouter = () =>
  new Router({
    routes: baseRouters,
  });

const router = createRouter();

export default router;
